import { createDate } from '@/core';

export const capitalize = (str: string): string => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const formatDate = (str: string): string => {
  if (!str?.length) { return str; }
  return createDate(str).format('DD.MM.YY');
};

export const formatCardMask = (str: string): string => {
  return `${str.slice(0, 4)} **** **** ${str.slice(-4)}`;
};
